import React, { useEffect } from 'react';
import Navbar from './Navbar';
import Container from '@mui/material/Container';
import { requestNotificationPermission } from '../config/firebase';
import { useAuth } from '../contexts/AuthContext';

const Layout = ({ children }) => {
  // Initialize web notifications
  useEffect(() => {
    const initNotifications = async () => {
      try {
        await requestNotificationPermission();
      } catch (error) {
        console.error('Error requesting notification permission:', error);
      }
    };
    
    initNotifications();
  }, []);

  return (
    <>
      <Navbar />
      <Container 
        sx={{ 
          mt: '95px', // Add margin to account for fixed navbar
          mb: 5,
          px: { xs: 2, sm: 3 },
          maxWidth: '100% !important'
        }}
      >
        {children}
      </Container>
    </>
  );
};

export default Layout; 